import { render, staticRenderFns } from "./LogTemplates.vue?vue&type=template&id=1908ba7f"
import script from "./LogTemplates.vue?vue&type=script&lang=js"
export * from "./LogTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports